export default __webpack_public_path__ + "static/section_4_details_3-5badba219bd41dbd7f9885702db0f408.png";